//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
  state: {
    inbounds: [],
    searchRequest: null,
  },
  mutations: {
    updateInbound(state, inbounds) {
      inbounds.forEach((it) => {
        it.apptTime = dateFormat.time(it.apptDate);
      });

      state.inbounds = inbounds;
    },
    updateSearchInboundRequest(state, searchRequest) {
      state.searchRequest = searchRequest;
    },
  },
  actions: {
    async inboundsList({ commit, state }, request) {
      const fallbackRequest = request || state.searchRequest;
      const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));
      
      if (requestToSend.apptDate)
      {
        requestToSend.apptDate = dateFormat.getLocalDateOnly(requestToSend.apptDate);
      }
      if (requestToSend.ciDate)
      {
        requestToSend.ciDate = dateFormat.getLocalDateOnly(requestToSend.ciDate);
      }
      const st = performance.now();
      //const result = await api.post('/api/w/fsi/WebSearchInbound', requestToSend);
      const result = await newAPIPost('/api/w/fsi/WebSearchInbound', requestToSend);
      commit('updateSearchInboundRequest', fallbackRequest);
      return commit('updateInbound', result);
    },
  },
  getters: {
    getInboundsList: state => state.inbounds,
  },
};
